import { render, staticRenderFns } from "./overseaLocation.vue?vue&type=template&id=61833f51&scoped=true&"
import script from "./overseaLocation.vue?vue&type=script&lang=js&"
export * from "./overseaLocation.vue?vue&type=script&lang=js&"
import style0 from "./overseaLocation.vue?vue&type=style&index=0&id=61833f51&scoped=true&lang=css&"
import style1 from "./overseaLocation.vue?vue&type=style&index=1&id=61833f51&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61833f51",
  null
  
)

export default component.exports